import {
    useMatomo
} from '@datapunt/matomo-tracker-react'

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    currentLanguage,
} from "src/shared_modules/i18n";

import { getMatomoConfig } from 'src/config/matomo';

import { DOCTITLE_PREFIX } from "src/constants";

const config = getMatomoConfig();

/**
 * ---------------------------------------------------------------------
 * native matomo api calls
 * ---------------------------------------------------------------------
 * @see:
 * https://developer.matomo.org/guides/tracking-javascript-guide
 * https://developer.matomo.org/api-reference/tracking-javascript
 */

const getVisitorId = async () => {
    return await new Promise((resolve, reject) => {
        window._paq.push([ function() {
            let id = this.getVisitorId();
            resolve(id);
        }]);
    });
}

const getUserId = async () => {
    return await new Promise((resolve, reject) => {
        window._paq.push([ function() {
            let id = this.getUserId();
            resolve(id);
        }]);
    });
}

const setUserId = (userid) => {
    window._paq.push([ function() {
        this.setUserId(userid);
    }]);
}

const resetUserId = () => {
    window._paq.push([ function() {
        this.resetUserId();
    }]);
}

/**
 * ---------------------------------------------------------------------
 * withMatomo
 * ---------------------------------------------------------------------
 * HOC to provide tracking functionalty for the component inside.
 *
 * @see https://www.npmjs.com/package/@datapunt/matomo-tracker-react
 *
 * @param  {React.Component} MyComponent [description]
 * @return {[type]}      [description]
 */

export function withMatomo(MyComponent) {
    const HOComponent = (props) => {
        const { trackPageView, trackEvent } = useMatomo();
        var lang = currentLanguage().code2;
        var evName = "";

        if( props.veuEvent ) {
            evName = " - "+ props.veuEvent.name.en;
        }
        // our custom page tracking function
        const trackPage = ( ) => {
            trackPageView({
                documentTitle: DOCTITLE_PREFIX + " " + evName,
                customDimensions: [
                    { id: config.visitDimensions.eventId, value: props.event.path },
                    { id: config.visitDimensions.langId, value: lang },
                    { id: config.actionDimensions.isLoggedInId, value: props.isLoggedIn.toString() }
                ]
            });
        }
        // event tracking function
        const fireEvent = ( category, action, name, value = null ) => {
            trackEvent({
                documentTitle: DOCTITLE_PREFIX + " " + evName,
                category: category,
                action: action,
                name: name, // optional
                value: value, // optional, numerical value
                // href: 'https://LINK.TO.PAGE', // optional
                customDimensions: [
                    { id: config.actionDimensions.isLoggedInId, value: props.isLoggedIn.toString() },
                ],
            });
        }
        // matomo api not supported by matomo-tracker-react
        // so we directly call _paq
        const trackerApi = {
            getVisitorId : getVisitorId,
            getUserId : getUserId,
            setUserId : setUserId,
            resetUserId : resetUserId,
        }

        return <MyComponent {...props}
                    trackPageView={trackPage}
                    trackEvent={fireEvent}
                    trackerApi={trackerApi}
                />;
    }

    HOComponent.propTypes = {
        veuEvent: PropTypes.object,
        isLoggedIn: PropTypes.bool,
    }

    const mapStateToProps = state => {
        return {
            veuEvent: state.event,
            isLoggedIn : state.user.loggedIn,
        };
    };
    return connect(
            mapStateToProps,
        )(HOComponent);

}
